import styled from 'styled-components';

export const Button = styled.button`
  box-sizing: border-box;
  padding: 10px 20px;
  color: white;
  background-color: rgba(38, 125, 224, 1);
  border-radius: 3px;
  border-width: 0;
  font-size: 14px;

  &:hover {
    background-color: rgba(18, 105, 204, 1);
  }
`;
